module.exports = __webpack_public_path__ + "img/pg2_1.3708d30b.png";